import type { PluginHooks } from '../types';
import type { Plugin } from '../registry';

export const makeRegistry = <T extends { [P in Plugin]: () => PluginHooks }>(
  registry: T
): T => {
  return registry;
};
